import React, { memo } from "react";

const PreviewQuestionDetails = (props) => {

    const { Question, formType } = props;

    const getImagePreview = (image) => {
        return URL.createObjectURL(image);
    };

    const LayoutForSingleQues = (options) => {
        let rows = [];

        if (options.items.length <= 3) {
            // Single column layout
            rows = options.items.map(item => [item]);
        } else if (options.items.length <= 6) {
            // Staggered two column layout (like 1 4 / 2 5 / 3 6)
            const rowCount = 3;
            const firstCol = options.items.slice(0, rowCount);
            const secondCol = options.items.slice(rowCount, rowCount * 2);

            for (let i = 0; i < rowCount; i++) {
                rows.push([
                    firstCol[i] !== undefined ? firstCol[i] : "",
                    secondCol[i] !== undefined ? secondCol[i] : ""
                ]);
            }
        } else {
            // Normal two column grid layout row by row
            for (let i = 0; i < options.items.length; i += 2) {
                rows.push([
                    options.items[i],
                    options.items[i + 1] !== undefined ? options.items[i + 1] : ""
                ]);
            }
        }

        return (
            <table>
                <tbody>
                    <table style={{ borderCollapse: "collapse", textAlign: "center" }}>
                        <tbody>
                            {rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {row.map((cell, cellIndex) => (
                                        cell !== "" &&
                                        <>
                                            <td style={{ border: "0", color: "#fff", width: "50%", verticalAlign: "center" }}>
                                                <div style={{ width: "100%", padding: "15px", border: "solid 1px #ccc", borderRadius: "25px" }}>
                                                    <div style={{ textAlign: "left", display: "inline-block", width: "75%" }}>
                                                        <i class="fa fa-circle-thin" style={{ fontSize: "20px" }}></i>&nbsp;&nbsp;{cell.fieldOption}
                                                    </div>
                                                    <div style={{ textAlign: "right", display: "inline-block", width: "25%" }}>
                                                        {cell.imageURL !== "" && cell.imageURL !== null && cell.imageURL !== undefined &&
                                                            <img src={cell.imageURL} alt="Option preview"
                                                                style={{ maxHeight: "36px", objectFit: "cover", borderRadius: "25px" }} />
                                                        }
                                                        {cell.image !== null && cell?.image?.name &&
                                                            <img src={getImagePreview(cell?.image)} alt="Option preview"
                                                                style={{ maxHeight: "36px", objectFit: "cover", borderRadius: "25px" }}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </td>
                                        </>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </tbody>
            </table>
        );
    }

    const CreateSingleQuestionLayout = () => {
        return (
            <>
                <table style={{ width: "100%" }}>
                    <tr>
                        <td style={{ width: "15%", border: "0px" }}>&nbsp;</td>
                        {Question.fieldOptions.sort?.((a, b) => a.fieldOrder - b.fieldOrder).map((option, index) =>
                            <>
                                <td style={{ borderRadius: "5px", border: "0px", width: `${(70 / Question.fieldOptions.length)}%` }}>
                                    <div style={{ padding: "15px", backgroundColor: option?.bgColorCode || '#9EC5FF', minHeight: "150px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <div style={{ textAlign: "center", color: "#fff", fontSize: "20px" }}>
                                            {option.imageURL !== "" && option.imageURL !== null && option?.imageURL !== undefined &&
                                                <img src={option.imageURL} alt="Option preview"
                                                    style={{
                                                        maxHeight: "48px",
                                                        maxWidth: "48px",
                                                        objectFit: "cover",
                                                        borderRadius: "2px",
                                                        marginBottom: "15px"
                                                    }}
                                                />
                                            }
                                            {option.image !== null && option?.image?.name &&
                                                <img src={getImagePreview(option?.image)} alt="Option preview"
                                                    style={{
                                                        maxHeight: "48px",
                                                        maxWidth: "48px",
                                                        objectFit: "cover",
                                                        borderRadius: "2px",
                                                        marginBottom: "15px"
                                                    }}
                                                />
                                            }
                                            <div style={{ clear: "both" }}></div>
                                            <strong>
                                                {option.fieldOption}
                                            </strong>
                                        </div>
                                    </div>
                                </td>
                            </>
                        )}
                        <td style={{ width: "15%", border: "0px" }}>&nbsp;</td>
                    </tr>
                </table>
            </>
        );
    }

    return (
        <>
            <div style={{ width: "100%", backgroundColor: "#323232", minHeight: "250px" }} >
                <div style={{ padding: "30px", textAlign: "center", color: "#fff", fontSize: "30px" }}>
                    {Question.fieldName}
                </div>
                <div style={{ clear: "both" }}></div>

                {formType === "single-question" && (
                    <CreateSingleQuestionLayout />
                )}
                {["general", "checklist"].includes(formType) &&
                    <>

                        <>
                            {(Question.fieldType === "single" || Question.fieldType === "multiple") &&
                                <>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "10%", border: "0px" }}>&nbsp;</td>
                                            <td style={{ border: "0px" }}>
                                                <LayoutForSingleQues items={Question.fieldOptions.sort?.((a, b) => a.fieldOrder - b.fieldOrder)} />
                                            </td>
                                            <td style={{ width: "10%", border: "0px" }}>&nbsp;</td>
                                        </tr>
                                    </table>
                                </>
                            }

                            {Question.fieldType === "free" &&
                                <>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "10%", border: "0px" }}>&nbsp;</td>
                                            <td style={{ border: "0px" }}>
                                                <textarea rows="10" readOnly style={{ backgroundColor: "transparent", width: "100%", borderRadius: "25px" }} />
                                            </td>
                                            <td style={{ width: "10%", border: "0px" }}>&nbsp;</td>
                                        </tr>
                                    </table>
                                </>
                            }
                        </>
                    </>
                }
                <div style={{ clear: "both" }}></div>
                <br />
                <br />
            </div>
        </>
    );
};

export default memo(PreviewQuestionDetails);
